import React, { useCallback } from "react";
import { Image, View, Text, Linking, StyleSheet, Platform } from "react-native";
import Constants from "expo-constants";

import { ScrollView, TouchableOpacity } from "react-native-gesture-handler";
import Colors from "../constants/Colors";
import FontStyles from "../constants/FontStyle";
import { useFocusEffect, useNavigation } from "@react-navigation/native";
import GenericHeader from "../components/headers/GenericHeader";

function AboutScreen() {
  const navigation = useNavigation();

  const gotoPolicy = () => {
    Linking.openURL("https://suplias.com/privacy");
  };

  const gotoTerms = () => {
    Linking.openURL("https://suplias.com/terms");
  };

  const backHandler = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else if (!navigation.dangerouslyGetParent()) {
      const routeNames = navigation.dangerouslyGetState().routeNames;
      if (routeNames.includes("Root")) {
        navigation.navigate("Root");
      } else {
        navigation.navigate("Intro");
      }
    }
  };

  useFocusEffect(
    useCallback(() => {
      navigation.setOptions({
        title: "About Suplias",
      });
    }, [])
  );

  return (
    <View style={styles.container}>
      <GenericHeader
        title={`About ${Constants.manifest.name}`}
        backAction={backHandler}
      />
      <ScrollView contentContainerStyle={styles.scrollView}>
        <Image
          source={require("../assets/images/main/Logo.png")}
          style={{ aspectRatio: 58 / 76, width: 46.5, height: undefined }}
        />
        <Text style={styles.brandName}>{Constants.manifest.name}</Text>
        <Text style={styles.versionCode}>
          Version {Constants.manifest.version} (
          {Constants.manifest.extra.versionCode})
        </Text>
        {Platform.OS === "android" && (
          <Text style={styles.versionCode}>
            package {Constants.manifest.android.package}
          </Text>
        )}
        <View style={{ marginTop: 25, flexDirection: "row" }}>
          <TouchableOpacity onPress={gotoTerms}>
            <Text style={styles.link}>Terms of Use</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={gotoPolicy}>
            <Text style={[styles.link, { marginLeft: 12 }]}>
              Privacy Policy
            </Text>
          </TouchableOpacity>
        </View>
        <Text style={styles.copyright}>© 2020 Suplias Technologies</Text>
      </ScrollView>
    </View>
  );
}

export default AboutScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.whiteColor,
  },
  scrollView: {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 16,
  },
  brandName: {
    marginTop: 25,
    ...FontStyles.size18,
    ...FontStyles.lh22,
    ...FontStyles.bold,
    color: Colors.shades._2,
  },
  versionCode: {
    ...FontStyles.gray,
    ...FontStyles.size12,
    ...FontStyles.lh14,
    ...FontStyles.normal,
    marginTop: 7,
  },
  link: {
    ...FontStyles.size12,
    ...FontStyles.lh14,
    ...FontStyles.bold,
    ...FontStyles.default,
    textTransform: "uppercase",
  },
  copyright: {
    ...FontStyles.size12,
    ...FontStyles.lh14,
    ...FontStyles.bold,
    ...FontStyles.gray,
    marginTop: 10,
  },
});
